import { ScriptDetails } from './ScriptDetails';

export default ScriptDetails;
